import joi from 'joi';

import { CompleteProfileFormData } from './types';

export const completeProfileSchema = joi.object<CompleteProfileFormData>({
  firstName: joi.string().required().min(2),
  lastName: joi.string().required().min(2),
  email: joi.string().email({ tlds: false }).required(),
  consents: joi
    .object({
      'general-terms': joi.boolean().valid(true),
      marketing: joi.boolean().optional(),
      'first-party': joi.boolean().optional(),
    })
    .optional(),
});
